// extracted by mini-css-extract-plugin
module.exports = {"container":"e_wB","collapsed":"e_xB","body":"e_yB","row":"e_zB","cell":"e_AB","expanded":"e_BB"};